<mat-toolbar class="footer-toolbar">

  <!-- Top Section -->
  <div class="footer-top">

    <!-- Left: Logo Section -->
    <div class="footer-logo">
      <div class="logo-inline">
        <img src="../../../assets/images/logo.png" alt="DigivCards.ai Logo" />
        <div class="logo-text">
          <h4>DigivCards.ai</h4>
          <h4>Networking platform</h4>
        </div>
      </div>

      <p class="description">
  <strong>DigivCards</strong> is a flagship digital vCard product from<br />
  <strong>Tamilarasi Technologies</strong>, designed to revolutionize<br />
  professional networking.<br />
  Our platform empowers individuals and businesses<br />
  to create, share, and manage smart digital business cards<br />
  with ease. Connect, engage, and grow in a paperless,<br />
  eco-friendly, and modern way—redefining how you present<br />
  your professional identity.
      </p>
    </div>

    <!-- Middle: Quick Links -->
    <div class="quick-links">
      <h4>Quick Links</h4>
      <a href="/dashboard">Dashboard</a>
      <a href="/cards">My Cards</a>
      <a href="/analytics">Analytics</a>
      <a href="/bookmarks">Bookmarks</a>
      <a href="/profile">Profile</a>
      <a href="/app-settings">Settings</a>
    </div>
    
    <!-- Company Info -->
    <div class="company-info">
  <div class="contact-header">
    <h4>Contact Us</h4>
  </div>

  <p class="company-description">
    Smarter Networking. Greener Future.<br>
    Transform your connections with our eco-friendly<br>
    digital business vCard platform.
  </p>

  <p>
    <mat-icon>location_on</mat-icon>
    1237, 2nd Floor, Subbulakshmi Nagar,<br />
    Landmark: HDFC Bank, Chennai – 600132
  </p>

  <p>
    <mat-icon>email</mat-icon>
    <a href="mailto:enquiry@tamilarasi.com" class="contact-link">
      enquiry&#64;tamilarasi.com
    </a>
  </p>

  <p>
    <mat-icon>phone</mat-icon>
    <a href="tel:7550196844" class="contact-link">
      +91 75501 96844
    </a>
  </p>
</div>


    <!-- Right: Social Links -->
    <div class="social-share">
      <div class="social-header">
        <h4>Social Links</h4>
      </div>

      <div class="social-icons">
        <a href="https://facebook.com" target="_blank">
          <img src="https://cdn.simpleicons.org/facebook/FFFFFF" width="20" height="20" alt="Facebook">
          <span>Facebook</span>
        </a>
        <a href="https://x.com" target="_blank">
          <img src="https://cdn.simpleicons.org/x/FFFFFF" width="20" height="20" alt="X">
          <span>X</span>
        </a>
        <a href="https://instagram.com" target="_blank">
          <img src="https://cdn.simpleicons.org/instagram/FFFFFF" width="20" height="20" alt="Instagram">
          <span>Instagram</span>
        </a>
        <a href="https://linkedin.com" target="_blank">
          <img src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/linkedin.svg" alt="LinkedIn" width="20" height="20">
          <span>LinkedIn</span>
        </a>
      </div>
    </div>

  </div>

  <!-- Bottom Section -->
  <div class="footer-bottom">
    <span>© 2025 <strong>DigivCards.ai</strong>.</span>
    <span>All rights reserved.</span>
    <span>Tamilarasi Technologies Private Limited.</span>
  </div>

</mat-toolbar>